import React, { useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * Displayed when OIDC authentication fails (e.g., stale state after
 * returning to the site with an expired session). Clears stored OIDC
 * state and redirects to trigger a fresh login flow.
 */
const AuthError = () => {
  useEffect(() => {
    // Clear stale OIDC state from storage so the next login starts clean
    const keysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith("oidc.")) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));

    // Redirect to home to trigger fresh auth
    window.location.href = "/";
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="h5" sx={{ mt: 3 }}>
        Session expired
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
        Redirecting to sign in again...
      </Typography>
    </Box>
  );
};

export default AuthError;
